// WhyRankridgeMPC.jsx
// All sections aligned in grid format, no extra right spacing.

import React from "react";
import { CheckCircle } from "lucide-react";

export default function WhyRankridgeMPC() {
  const sections = [
    {
      title: "1. India’s Best Faculty – The Rankridge Powerhouse",
      points: [
        "Handpicked mentors from IITs, NITs & research institutions",
        "Decades of IIT-JEE expertise to simplify toughest concepts",
        "MPC syllabus + advanced IIT-JEE topics integrated",
        "Step-by-step guidance from NCERT basics to JEE Advanced",
        "Weekly alignment with board exams + competitive prep",
      ],
    },
    {
      title: "2. Proven JEE Results That Speak for Themselves",
      points: [
        "Consistent record of All India Rank holders in JEE Mains & Advanced",
        "Alumni at IIT Bombay, IIT Delhi, IIT Madras, IIT Kanpur, IIT Kharagpur",
        "Success stories at NIT Warangal, NIT Trichy, IIIT Hyderabad",
        "Top 100 AIR ranks achieved year after year",
      ],
      bg: "bg-neutral-50 border border-neutral-200",
    },
    {
      title: "3. Stress-Free Learning, Stress-Free Success",
      points: [
        "Yoga & mindfulness sessions for clarity",
        "Stress-busting activities & motivational talks",
        "Balanced academic + personal timetable",
        "We nurture instead of exhausting students",
      ],
    },
    {
      title: "4. Limited Strength = Unlimited Personal Attention",
      points: [
        "Only 35–40 students per batch",
        "Daily doubt clearing sessions",
        "Individual mentoring & progress tracking",
        "No overcrowding – every student matters",
      ],
      // bg: "bg-gradient-to-r from-teal-600 to-emerald-500 text-white",
      // iconColor: "text-lime-300",
    },
    {
      title: "5. India’s Finest JEE Study Material",
      points: [
        "Chapter-wise handbooks & concise concept notes",
        "Daily Practice Papers (DPPs)",
        "Full-length mock tests for real exam practice",
        "Video solutions accessible via Rankridge app",
      ],
    },
    {
      title: "6. Healthy & Hygienic Food for Students",
      points: [
        "Protein-rich meals & balanced diet",
        "Morning milk, fruits & evening snacks",
        "Hygiene-monitored kitchens",
        "Nutritious meals = sharp mind + healthy body",
      ],
    },
    {
      title: "7. Digital Progress Monitoring for Parents",
      points: [
        "Weekly SMS reports & monthly progress cards",
        "Live access to attendance, test scores & feedback",
        "Performance trends visible anytime",
      ],
      // bg: "bg-gradient-to-r from-teal-600 to-emerald-500 text-white",
      // iconColor: "text-lime-300",
    },
    {
      title: "8. Premium Campus with Flexible Living",
      points: [
        "Full Residential Campus",
        "Semi-Residential (Study + Parent Pickup)",
        "Day Scholar Program",
      ],
      // bg: "bg-gradient-to-r from-teal-600 to-emerald-500 text-white",
      // iconColor: "text-lime-300",
    },
  ];

  return (
    <section className="bg-white py-1" id="rankridge-mpc">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center ">
          <h2 className="text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl">
            Hyderabad’s Most Trusted Intermediate MPC College with IIT-JEE Coaching
          </h2>
          <p className="mt-4 text-lg text-neutral-600">
            Why Rankridge is the No.1 Choice for Every IIT-JEE Aspirant
          </p>
        </div>

        {/* Features Grid */}
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-12">
          {sections.map((sec, i) => (
            <div
              key={i}
              className={`rounded-2xl p-8 ${
                sec.bg ? sec.bg : "bg-white border border-neutral-200"
              }`}
            >
              <h3
                className={`text-2xl font-semibold ${
                  sec.bg?.includes("text-white")
                    ? "text-white"
                    : "text-neutral-900"
                }`}
              >
                {sec.title}
              </h3>
              <ul className="mt-4 space-y-2">
                {sec.points.map((p, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <CheckCircle
                      className={`mt-1 h-5 w-5 ${
                        sec.iconColor
                          ? sec.iconColor
                          : sec.bg?.includes("gradient")
                          ? "text-white"
                          : "text-teal-600"
                      }`}
                    />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-20 rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-600 p-8 text-center text-white">
          <h3 className="text-2xl font-bold">
            Join Rankridge – Step Into the Ranks of India’s Best
          </h3>
          <p className="mt-2 text-white/90">
            Admissions Open for MPC with IIT-JEE Coaching in Hyderabad
          </p>
          <p className="mt-1 text-white/80">
            📞 Book a campus tour or call our counsellors today!
          </p>
          <button className="mt-6 rounded-lg bg-white px-6 py-3 font-semibold text-teal-600 shadow hover:bg-neutral-100">
            Apply Now
          </button>
        </div>
      </div>
    </section>
  );
}
